export default __webpack_public_path__ + "static/media/hayes_grey.b5431e66.jpeg";